@if (documents) {
  <div class="wc-spy-target" [sdSpyTarget]="componentUid"></div>
  <wc-wrapper [contentWrapper]="wrapper">
    <sd-documents sd-component-wrapper-component
      [documents]="documents"
      (downloadedDocument)="onClick($event)"
      [brand]="brandCorner"
    />
  </wc-wrapper>
}
